'use client';

import Image from '@src/components/atoms/safe-image';
import { useRouter } from 'next/navigation';

import Century21 from '@public/png/century-21-black-1.png';
import One21 from '@public/png/one21.png';

const Dedicated = ({ onlineProfile }) => {
  const router = useRouter();
  const companyName = onlineProfile?.data?.data?.office_name || 'Century 21';
  const companyAddress = onlineProfile?.data?.data?.office_address || '';

  const handleToHomepage = () => {
    router.push(`/marketing/${onlineProfile?.data?.data?.username}`);
  };
  return (
    <div
      className="w-full mx-auto max-w-[1344px] pt-6
      dd2-2xl:px-[24px] dd2-2xl:max-w-[unset]
      dd2-xl:pb-[100px] dd2-xl:pt-6"
    >
      <div
        className="flex justify-between gap-[24px] 
        dd2-lg:block"
      >
        <div onClick={handleToHomepage} className="flex flex-col justify-start items-start w-full max-w-[324px] 
          dd2-xl:mb-6 dd2-2xl:max-w-[224px]">
          <Image
            src={Century21}
            alt="CENTURY 21 Indonesia"
            width="1000"
            height="1000"
            className="cursor-pointer object-contain w-[177px] mb-2"
          />
          <p className="mb-4 text-[15px] text-[#252526] font-typold-extended-medium leading-[10.68px] tracking-[0.16px]">
            {companyName}
          </p>

          <div
            className="flex items-center cursor-pointer"
            
          >
            <p className="text-[14px] font-satoshi text-[#808285] mr-1">
              Powered by
            </p>
            <Image
              src={One21}
              alt="One21"
              width="auto"
              height="auto"
              className="object-contain w-[44.769px] h-[12px]"
            />
          </div>
        </div>

        <div
          className="w-full flex items-start gap-[48px] 
         dd2-xl:block"
        >
          <div
            className="flex flex-col gap-[12px] max-w-[546px] 
            dd2-xl:mb-6 dd2-xl:max-w-[unset]"
          >
            <p className="text-[21px]/[25.2px] tracking-[-0.42px] font-satoshi-bold">
              Kantor
            </p>
            <p className="text-[14px]/[19.6px] font-satoshi">
              {companyAddress}
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between border-t-[0.5px] py-[12px] mt-[48px] border-solid border-[#E6E7E8] dd2-xl:block">
        <p className="text-[#808285] text-[14px] font-satoshi dd2-xl:mb-2">
          Designed by ONE21
        </p>
        <p className="text-[#808285] text-[14px] font-satoshi">
          © CENTURY 21 Indonesia. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Dedicated;
